import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

/**
 * Returns the discount of a product, formatted as a string.
 *
 * @param product - The recommended product to get the discount for.
 *
 * @example
 * const discount = recommendationAccessorGetProductDiscount(product)
 * @returns The discount as a string e.g "−20%", or undefined if the product is not discounted.
 */
export const recommendationAccessorGetProductDiscount = (
  product: GkAirRecommendedProductDataWeb,
): string | undefined => {
  return product.reduced === 'true'
    ? `−${Number(product.discount_in_percent)}%`
    : undefined
}
